import React, { Component, createRef } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';

export default class CustomFileMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSrc: null,
      isModal: false,
      crop: null,
      imageResult: null,
      fileName: '',
    };
    this.imageRef = createRef();
  }

  componentDidMount() {
    this.prepareImage(this.props.image);
  }

  componentDidUpdate(prevProps) {
    if (this.props.image !== prevProps.image) {
      this.prepareImage(this.props.image);
    }
  }

  prepareImage = (image) => {
    if (!image || !image.file) {
      this.setState({
        imageResult: null,
        imageSrc: null,
        crop: null,
        fileName: '',
      });
      return;
    }

    if (image.file.startsWith('data:image')) {
      this.setState({ imageResult: image.file });
    } else {
      this.convertImageToDataURL(image.file, (dataUrl) => {
        this.setState({ imageResult: dataUrl });
        this.props.setImg({ name: image.name || 'image', file: dataUrl });
      });
    }
  };

  convertImageToDataURL = (url, callback) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataUrl = canvas.toDataURL('image/jpeg');
      callback(dataUrl);
    };
  };

  handleImageUploadClick = () => {
    if (this.imageRef && this.imageRef.current) {
      this.imageRef.current.click();
    }
  };

  updateImage = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const imageUrl = URL.createObjectURL(file);
      const fileName = file.name;

      const img = new Image();
      img.src = imageUrl;
      img.onload = () => {
        const minSize = Math.min(img.width, img.height);
        const cropSize = {
          unit: 'px',
          width: this.props.defaultCropSize?.width || minSize,
          height: this.props.defaultCropSize?.height || minSize,
          x: (img.width - (this.props.defaultCropSize?.width || minSize)) / 2,
          y: (img.height - (this.props.defaultCropSize?.height || minSize)) / 2,
        };
        this.setState({
          imageSrc: imageUrl,
          fileName: fileName,
          crop: cropSize,
          isModal: true,
        });
      };
    }
  };

  handleCropComplete = (crop) => {
    const { imageSrc } = this.state;
    if (imageSrc && crop.width && crop.height) {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);

        const croppedImageUrl = canvas.toDataURL('image/jpeg');
        this.setState({ imageResult: croppedImageUrl });
      };
    }
  };

  resetModal = () => {
    this.setState({ isModal: false, imageSrc: null });
  };

  saveImage = () => {
    const { fileName, imageResult } = this.state;
    const { image } = this.props;
    const result = imageResult || image?.file;

    if (this.props.setImg) {
      this.props.setImg({ name: fileName || 'image', file: result });
    }
    this.setState({ isModal: false });
  };

  renderImageUpload = () => {
    const { imageResult } = this.state;
    const { image } = this.props;

    return (
      <div className="cursor-pointer">
        {imageResult ? (
          <div className="position-relative bg-white">
            <img src={imageResult} alt="Cropped" className="w-full h-auto" style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover' }} />
            <FontAwesomeIcon
              icon={faTimes}
              className="position-absolute top-0 end-0 m-2 text-danger cursor-pointer"
              onClick={this.props.handleClose}
            />
          </div>
        ) : (
          <div className="py-3 px-1 rounded-sm text-center" onClick={this.handleImageUploadClick}>
            <FontAwesomeIcon icon={faPlus} className="text-gray fs-4" />
          </div>
        )}
        <input ref={this.imageRef} type="file" accept="image/*" className="d-none" onChange={this.updateImage} />
      </div>
    );
  };

  render() {
    const { imageSrc, crop, isModal } = this.state;

    return (
      <div>
        {this.renderImageUpload()}

        <Modal isOpen={isModal} toggle={this.resetModal} size="lg" centered>
          <ModalHeader toggle={this.resetModal}>Edit Gambar</ModalHeader>
          <ModalBody>
            {imageSrc && (
              <ReactCrop src={imageSrc} crop={crop} onChange={(newCrop) => this.setState({ crop: newCrop })} onComplete={this.handleCropComplete} />
            )}
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-outline-secondary" onClick={this.resetModal}>
              Batal
            </button>
            <button className="btn btn-primary" onClick={this.saveImage}>
              Simpan
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

CustomFileMessage.defaultProps = {
  image: null,
  defaultCropSize: null,
  handleClose: () => {},
};
